import { PREFIX } from './base';

export const DEFAULT_LABEL_LIMIT = `${PREFIX}_LABEL_LIMIT`;
export const DEFAULT_LABEL_ALIGN = `${PREFIX}_LABEL_ALIGN`;
export const DEFAULT_LABEL_TEXT = `${PREFIX}_LABEL_TEXT`;
export const DEFAULT_LABEL_VISIBLE = `${PREFIX}_LABEL_VISIBLE`;
export const DEFAULT_LABEL_X = `${PREFIX}_LABEL_X`;
export const DEFAULT_LABEL_Y = `${PREFIX}_LABEL_Y`;
